export const KPI_CONFIG = {
    //OUTPOST
    CONNECTEDSTATUS: {
        label: 'AWS Outpost / ConnectedStatus',
        units: 'Count'
    },
    INSTANCEFAMILYCAPACITYAVAILABILITY: {
        label: 'AWS Outpost / InstanceFamilyCapacityAvailability',
        units: 'Percent'
    },
    AVAILABLEINSTANCETYPECOUNT: {
        label: 'AWS Outpost / AvailableInstanceTypeCount',
        units: 'Count'
    },
    USEDINSTANCETYPECOUNT: {
        label: 'AWS Outpost / UsedInstanceTypeCount',
        units: 'Count'
    },
    EBSVOLUMETYPECAPACITYUTILIZATION: {
        label: 'AWS Outpost / EBSVolumeTypeCapacityUtilization',
        units: 'Percent'
    },
    EBSVOLUMETYPECAPACITYAVAILABILITY: {
        label: 'AWS Outpost / EBSVolumeTypeCapacityAvailability',
        units: 'Percent'
    },
    EBSVOLUMETYPECAPACITYUTILIZATIONGB: {
        label: 'AWS Outpost / EBSVolumeTypeCapacityUtilizationGB',
        units: 'Gigabyte'
    },
    EBSVOLUMETYPECAPACITYAVAILABILITYGB: {
        label: 'AWS Outpost / EBSVolumeTypeCapacityAvailabilityGB',
        units: 'Gigabyte'
    },
    CAPACITYEXCEPTIONS: {
        label: 'AWS Outpost / CapacityExceptions',
        units: 'Count'
    },

    //EC2_AWS
    EBSWRITEBYTES: {
        label: 'AWS EC2 / EBSWriteBytes',
        units: 'Bytes'
    },
    METADATANOTOKEN: {
        label: 'AWS EC2 / MetadataNoToken',
        units: 'Count'
    },
    DISKREADBYTES: {
        label: 'AWS EC2 / DiskReadBytes',
        units: 'Bytes'
    },
    NETWORKPACKETSOUT: {
        label: 'AWS EC2 / NetworkPacketsOut',
        units: 'Count'
    },
    DISKWRITEOPS: {
        label: 'AWS EC2 / DiskWriteOps',
        units: 'Count'
    },
    DISKREADOPS: {
        label: 'AWS EC2 / DiskReadOps',
        units: 'Count'
    },
    EBSWRITEOPS: {
        label: 'AWS EC2 / EBSWriteOps',
        units: 'Count'
    },
    CPUUTILIZATION: {
        label: 'AWS EC2 / CPU utilization',
        units: 'Percent'
    },
    EBSREADBYTES: {
        label: 'AWS EC2 / EBSReadBytes',
        units: 'Bytes'
    },
    DISKWRITEBYTES: {
        label: 'AWS EC2 / DiskWriteBytes',
        units: 'Bytes'
    },
    'EBSBYTEBALANCE%': {
        label: 'AWS EC2 / EBSByteBalance%',
        units: 'Percent'
    },
    NETWORKPACKETSIN: {
        label: 'AWS EC2 / NetworkPacketsIn',
        units: 'Count'
    },
    STATUSCHECKFAILED_INSTANCE: {
        label: 'AWS EC2 / StatusCheckFailed(Instance)',
        units: 'Byte'
    },
    NETWORKOUT: {
        label: 'AWS EC2 / NetworkOut',
        units: 'Bytes'
    },
    NETWORKIN: {
        label: 'AWS EC2 / NetworkIn',
        units: 'Bytes'
    },
    EBSREADOPS: {
        label: 'AWS EC2 / EBSReadOps',
        units: 'Count'
    },
    'EBSIOBALANCE%': {
        label: 'AWS EC2 / EBSI/OBalance%',
        units: 'Percent'
    },

    //S3
    BUCKETSIZEBYTES: {
        label: 'AWS S3 / BucketSizeBytes',
        units: 'Bytes'
    },
    NUMBEROFOBJECTS: {
        label: 'AWS S3 / NumberOfObjects',
        units: 'Count'
    },

    //EBS
    VOLUMEREADBYTES: {
        label: 'EBS / VolumeReadBytes',
        units: 'Bytes'
    },
    VOLUMEWRITEBYTES: {
        label: 'EBS / VolumeWriteBytes',
        units: 'Bytes'
    },
};

export const KPI_TABS = {
    OUTPOST: {
        key: 'OUTPOST',
        namespace: 'AWS/Outposts',
        title: 'Outpost',
        kpis: [
            'CONNECTEDSTATUS',
            'INSTANCEFAMILYCAPACITYAVAILABILITY',
            'AVAILABLEINSTANCETYPECOUNT',
            'USEDINSTANCETYPECOUNT',
            'EBSVOLUMETYPECAPACITYUTILIZATION',
            'EBSVOLUMETYPECAPACITYAVAILABILITY',
            'EBSVOLUMETYPECAPACITYUTILIZATIONGB',
            'EBSVOLUMETYPECAPACITYAVAILABILITYGB',
            'CAPACITYEXCEPTIONS'
        ]
    },
    EC2_AWS: {
        key: 'EC2_AWS',
        namespace: 'AWS/EC2',
        title: 'EC2 compute',
        kpis: [
            'CPUUTILIZATION',
            'METADATANOTOKEN',
            'DISKREADOPS',
            'DISKWRITEOPS',
            'DISKREADBYTES',
            'DISKWRITEBYTES',
            'NETWORKIN',
            'NETWORKOUT',
            'NETWORKPACKETSIN',
            'NETWORKPACKETSOUT',
            'EBSREADOPS',
            'EBSWRITEOPS',
            'EBSREADBYTES',
            'EBSWRITEBYTES',
            'EBSBYTEBALANCE%',
            'EBSIOBALANCE%',
        ]
    },
    S3: {
        key: 'S3',
        namespace: 'AWS/S3',
        title: 'S3 storage',
        kpis: ['BUCKETSIZEBYTES', 'NUMBEROFOBJECTS']
    },
    EBS: {
        key: 'EBS',
        namespace: 'AWS/EBS',
        title: 'EBS storage',
        kpis: ['VOLUMEREADBYTES', 'VOLUMEWRITEBYTES']
    }
};
